<template>
    <v-container>
        <v-card>
          <v-card-title>
              Otras Gestiones
          </v-card-title>
          <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-data-table 
                      :headers="headers"
                      :loading="loading"
                      :items="listaGestiones"
                      v-model="selectedRow"
                      :server-items-length="totalItems"
                      :options.sync="options"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                    <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                        No se encontraron gestiones.
                        </v-alert>
                    </template>
                    <template v-slot:item="{ item }">
                        <tr>
                            <td class="text-xs-left caption">
                              <tr>
                                {{ item.fecha | dateParse('YYYY-MM-DD') | dateFormat('DD-MM-YYYY')}}
                              </tr>
                              <tr  class="text-center font-weight-light caption">
                                {{ item.fecha | dateParse('YYYY-MM-DD HH:mm') | dateFormat('HH:mm')}}
                              </tr>
                            </td>
                            <td class="text-xs-left caption">{{ item.tareaDescripcion }}</td>
                            <td class="text-xs-left caption">
                              <tr>
                              {{ item.respuestaDescripcion}}
                              </tr>  
                              <tr>
                                <span class="overline">{{ item.comentarios}}</span> 
                              </tr>                                
                            </td>
                            <td class="text-xs-left caption ">{{ item.motivoRechazoDescripcion}}</td>
                            <td class="text-xs-left caption ">{{ item.responsable}}</td>
                            <td class="text-xs-left caption">
                              <v-switch v-model="item.destacada" @change="destacar(item.id,item.destacada)"></v-switch>
                            </td>                      
                        </tr>
                    </template>
                    </v-data-table>
                  </v-col>
              </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import Vue from 'vue'
import { http } from '@/axios'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: () => ({
    editMode: true,
    loading: false,
    options: { // definición de paginación
        sortDesc:[true],
        sortBy:['fecha'],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20]
    },
    totalItems: 0, // va afuera de pagination
    headers: [ // definición de columnas
        { text: 'Fecha', value: 'fecha', width: 100},
        { text: 'Tarea', value: 'tarea'},
        { text: 'Respuesta', value: 'respuesta'},
        { text: 'Motivo Rechazo', value: 'motivoRechazo'},
        { text: 'Responsable', value: 'responsable'},
        { text: 'Destacada', value: 'destacada'}
    ],        
    listaGestiones: [], // registros
    selectedRow: []
  }),
  props: ['personaId'],
  watch:{
    'personaId': function(personaId){
        this.loadGestiones(personaId);
    },
    options :{
        handler(){
          this.loadGestiones(this.personaId);
        },
        deep: true
    },
  },
  computed: {  
  },
  created () {
    // if(this.personaId)
    //   this.loadGestiones(this.personaId);
  },
  methods: {
    ...mapMutations(['alertError']),
    ...mapActions(['']),
    async loadGestiones(personaId){
      if(!personaId) return;

      this.loading = true;
      this.emitLoading(true);
      try{
        //tipoGestion
        var result= await http.get('gestion/listgestionesporpersona?personaId='+ personaId + '&tipoGestionId=2' +  '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'true'));

        this.listaGestiones = result.list;
        this.totalItems = result.totalCount;

        console.log(this.listaGestiones)
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
      this.emitLoading(false);
    },
    async destacar (id,estado){
      if(!id) return;

      try{

        await http.put('gestion/updategestiondestacada',JSON.stringify({
          id: id,
          estado: estado
        }))

        //this.loadGestiones();



      }catch(error){
        console.error(error);
      }
    },
    emitLoading (value) {
      this.$emit('loading-changed', value)
    }
  },
  
}

</script>